import { BitbucketPipelinesIntegrations } from '../../../../templates/bitbucket/bitbucket-pipelines-integrations';

const UniformBitbucketSearchIntegration = () => {
	return <BitbucketPipelinesIntegrations />;
};

export default UniformBitbucketSearchIntegration;
